import React, { useEffect, ReactNode, useRef, useState } from 'react';

import './redeem-rebates-banner.scss';

export interface BannerBottom {
    component: ReactNode;
    marginTop: number | string;
}

interface Props {
    topComponent?: ReactNode;
    bottomComponent?: ReactNode;
    bottomButOneComponent?: ReactNode;
    topMasthead?: string;
    backgroundImageDesktop: string;
    backgroundImageMobile: string;
}

export const RedeemRebatesBanner = (props: Props) => {
    const TABLET_BREAKPOINT = 768;
    const DEFAULT_HEIGHT_VALUE = 0;
    const topDivRef = useRef<HTMLDivElement>(null);
    const bottomDivRef = useRef<HTMLDivElement>(null);
    const [backgroundImage, setBackgroundImage] = useState('');
    const [topDivHeight, setTopDivHeight] = useState(DEFAULT_HEIGHT_VALUE);
    const [bottomDivHeight, setBottomDivHeight] = useState(
        DEFAULT_HEIGHT_VALUE
    );

    useEffect(() => {
        let movementTimer: NodeJS.Timeout | null = null;

        const configureLayout = () => {
            const bottomDivHeightValue =
                bottomDivRef?.current?.clientHeight || DEFAULT_HEIGHT_VALUE;
            setBottomDivHeight(bottomDivHeightValue / 2);

            const topDivHeightValue =
                topDivRef?.current?.clientHeight || DEFAULT_HEIGHT_VALUE;
            setTopDivHeight(topDivHeightValue);

            const isMobile = window.innerWidth <= TABLET_BREAKPOINT;
            if (isMobile) setBackgroundImage(props.backgroundImageMobile);
            else setBackgroundImage(props.backgroundImageDesktop);
        };

        configureLayout();

        window.addEventListener('resize', () => {
            if (movementTimer) clearTimeout(movementTimer);
            movementTimer = setTimeout(configureLayout, 10);
        });

        return () => {
            window.removeEventListener('resize', () => {
                if (movementTimer) clearTimeout(movementTimer);
            });
        };
    }, [props.backgroundImageMobile, props.backgroundImageDesktop]);

    return (
        <div className="redeem-rebates-banner">
            {props.topComponent && (
                <div
                    className="redeem-rebates-top"
                    style={{
                        minHeight: `${topDivHeight + bottomDivHeight}px`,
                        backgroundImage: `url('${backgroundImage}')`,
                    }}
                >
                    {props.topMasthead && (
                        <div className="redeem-rebates-tabs">
                            {props.topMasthead}
                        </div>
                    )}

                    <div className="redeem-rebates-cta" ref={topDivRef}>
                        {props.topComponent}
                    </div>
                </div>
            )}
            {props.bottomButOneComponent && (
                <div className="redeem-rebates-bottom-but-one-container">
                    <div
                        className="redeem-rebates-bottom-but-one"
                        ref={bottomDivRef}
                    >
                        {props.bottomButOneComponent}
                    </div>
                </div>
            )}
            {props.bottomComponent && (
                <div className="redeem-rebates-bottom-container">
                    <div className="redeem-rebates-bottom" ref={bottomDivRef}>
                        {props.bottomComponent}
                    </div>
                </div>
            )}
        </div>
    );
};
